import {
    Directive,
    ComponentFactoryResolver,
    OnInit,
    ViewContainerRef,
    Type,
    ComponentRef,
    OnDestroy,
} from '@angular/core';
import { DialogService } from '../services/dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface IDialog<T> {
    data: T;
}

@Directive({
    selector: '[appDialogContainer]',
    standalone: false
})
export class DialogDirective implements OnInit, OnDestroy {
    private ref: ComponentRef<IDialog<any>>;
    private destroy = new Subject<void>();

    constructor(
        private viewContainerRef: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private dialogService: DialogService
    ) {}

    ngOnInit() {
        this.dialogService.dialog$.pipe(takeUntil(this.destroy)).subscribe((output) => {
            this.close(null);
            if (output == null) {
                return;
            }
            this.open(output);
        });

        this.dialogService.close$.pipe(takeUntil(this.destroy)).subscribe((output) => {
            this.close(output);
        });
    }

    ngOnDestroy() {
        this.close();
        this.destroy.next();
        this.destroy.unsubscribe();
    }

    open(output: { component: Type<IDialog<any>>; data: any }) {
        const factory = this.resolver.resolveComponentFactory(output.component);
        this.ref = this.viewContainerRef.createComponent(factory);
        this.ref.instance.data = output.data;
        this.viewContainerRef.element.nativeElement.appendChild(this.ref.location.nativeElement);
    }

    close(data?: any) {
        if (this.ref != null) {
            this.ref.destroy();
            this.ref.location.nativeElement.remove();
            this.ref = null;
            this.dialogService.close(data);
        }
    }
}
